define('view/disclosure/modals/disclosure.type.modal',['require','exports','module','underscore','uikit/uikit','blockit','backbone.radio','fukit/fukit','fukit/fukit','fukit/fukit'],function(require, exports, module) {
  //prettier-ignore
  var _       = require('underscore'),
      UIKit   = require('uikit/uikit'),
      BlocKit = require('blockit'),
      Radio   = require('backbone.radio'),
      Factory = require('fukit/fukit').Factory,

      //Behaviors
      EnableOnlyOnUnsavedChangesBehavior = require('fukit/fukit').EnableOnlyOnUnsavedChangesBehavior;

  var redirectToDisclosureForm = function(id, path) {
    const ROUTE = '/form/answer/';
    const DISCLOSEE_PARAMETER = '/disclosee';
    
    if(localStorage.getItem('productNewCoiUiValue') === 'true'){
      location.assign(location.origin + '/coi-react' + path + ROUTE + id + DISCLOSEE_PARAMETER);
    }else{
      location.assign(location.origin + '/coi#form/answer/' + id + DISCLOSEE_PARAMETER);
    }
  };

  var DisclosureTypeModal = UIKit.Modal2.extend({
    className: 'ui modal confirmation',

    options: _.extend({}, UIKit.Modal2.prototype.options, { closable: true }),

    header: {
      type: UIKit.Modal2.HeaderView,
      text: 'New Disclosure',
    },

    content: function() {
      return {
        components: [
          {
            type: BlocKit.FormContainerView,
            basic: true,
            components: [
              {
                content: {
                  type: UIKit.CheckboxGroup,
                  radio: true,
                  collection: Radio.request('AppKit.resourceService', 'resource', 'disclosureTypeCollection'),
                  bindings: {
                    value: 'templateTypeDescription',
                  },
                  childView: UIKit.Checkbox.extend({
                    template: 'local.checkbox',
                    useLabel: true,
                  }),
                  childBindings: {
                    text: 'displayName',
                  },
                  behaviors: {
                    setSelectedDisclosureType: {
                      behaviorClass: Mn.Behavior.extend({
                        onFirstBeforeRender: function() {
                          this.listenTo(this.view, 'change', function() {
                            if (arguments[2] != null) {
                              var model = Radio.request('AppKit.resourceService', 'resource', 'disclosureModel');
                              model.set(arguments[2].attributes);
                            }
                          });
                        },
                      }),
                    },
                  },
                },
              },
            ],
          },
        ],
      };
    },

    actions: function() {
      return {
        components: [
          {
            type: UIKit.Button,
            text: 'Next',
            icon: 'arrow right',
            iconRight: true,
            disabled: true,
            color: 'primary',
            model: Radio.request('AppKit.resourceService', 'resource', 'disclosureModel'),
            behaviors: {
              EnableOnlyOnUnsavedChangesBehavior: {
                behaviorClass: EnableOnlyOnUnsavedChangesBehavior,
              },

              InvokeMethodOnEventBehavior: {
                events: {
                  press: {
                    method: function(model) {
                      var currentProductNameHeader = _.isUndefined($.ajaxSettings.headers)
                        ? false
                        : $.ajaxSettings.headers['Product-Name'];

                      var buttonView = this.view;

                      Promise.try(function() {
                        $.ajaxSetup({ headers: { 'Product-Name': 'COI' } });
                        buttonView.loading = true;
                        return model.save();
                      })
                        .catch(function(e) {
                          console.log(e);
                          buttonView.loading = false;
                        })
                        .finally(function() {
                          if (buttonView.loading) {
                            var ROUTE = '/form/answer/';
                            var DISCLOSEE_PARAMETER = '/disclosee';
                            var id = model.id;
                            model.clear();
                            model.unset();
                            window.onbeforeunload = null;
                            // The next couple lines allow the configuration to override the target URL via app-develop.yml
                            // or any similar configuration file. In normal operation, location.assign is something like
                            // <tenantname>.<environment>.cayuse.com but when running locally, the profile-page app
                            // is at one port (e.g. localhost:9002) and the coi-web app is at another (e.g. localhost:9001).
                            // Set the COI_URL to match when running locally.
                            var COI_URL = location.origin + '/coi-react';
                            var config = require('fukit/fukit').config;
                            if (config.get('COI_URL')) {
                              COI_URL = config.get('COI_URL');
                            }
                            if(localStorage.getItem('productNewCoiUiValue') === 'true'){
                              location.assign(COI_URL + ROUTE + id + DISCLOSEE_PARAMETER);
                            }else{
                              location.assign(location.origin + '/coi#form/answer/' + id + DISCLOSEE_PARAMETER);
                            }
                       
                          }
                        });
                    },
                  },
                },
                behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
              },
            },
          },
        ],
      };
    },
  });

  module.exports = DisclosureTypeModal;
});

